import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import exportTable from '../../../lib/exportTable';
import { IEnrolledStudentSummary } from '../../../models/statistics.model';
import { RootState } from '../../../store/rootReducer';
import DownloadButton from '../../DownloadButton';
import moment from 'moment';

interface IProps {
  res: any;
}

const Summary: FC<IProps> = ({ res }) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const [data, setData] = useState<IEnrolledStudentSummary[]>([]);

  useEffect(() => {
    if (res.length) {
      // @ts-ignore
      const _data: any = _.cloneDeep(res.at(0)?.data);
      _data.forEach((item: any) => {
        // @ts-ignore
        const prevCampusData = res
          .at(1)
          ?.data?.find(
            (subitem: any) => subitem.campusCode === item.campusCode,
          );
        if (prevCampusData) {
          item.prevReCount = prevCampusData?.reCount;
          item.diffPercent = Math.round(
            ((item.reCount - item.prevReCount) / item.prevReCount) * 100,
          );
        } else {
          item.prevReCount = 0;
          item.diffPercent = null;
        }
      });

      if (auth.hqYn === 'Y') {
        const total: any = {
          campusCode: 'total',
          campusEngName: 'Total',
          campusKorName: t('student.student.column47'),
          reCount: _data.reduce(
            (acc: number, cur: any) => acc + cur.reCount,
            0,
          ),
          prevReCount: _data.reduce(
            (acc: number, cur: any) => acc + cur.prevReCount,
            0,
          ),
          plCount: _data.reduce(
            (acc: number, cur: any) => acc + cur.plCount,
            0,
          ),
          s1Count: _data.reduce(
            (acc: number, cur: any) => acc + cur.s1Count,
            0,
          ),
          s2Count: _data.reduce(
            (acc: number, cur: any) => acc + cur.s2Count,
            0,
          ),
          bookbuyerCount: _data.reduce(
            (acc: number, cur: any) => acc + cur.bookbuyerCount || 0,
            0,
          ),
        };
        total.diffPercent = total.prevReCount
          ? Math.round(
              ((total.reCount - total.prevReCount) / total.prevReCount) * 100,
            )
          : null;
        _data.push(total);
      }

      setData(_data);
    }
  }, [res]);

  const onExportTable = () => {
    const currentDate = moment(new Date());
    exportTable(
      columns,
      data,
      `${t('statistics.studentEnrolled.9')}_(${currentDate.format(
        'YYYYMMDD',
      )})`,
      t('statistics.attendance.Tab1'),
      [12, 10, 12, 10, 10, 10, 10],
    );
  };

  const columns: TableColumnsType<IEnrolledStudentSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column1'),
      dataIndex: 'reCount',
      key: 'reCount',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column10'),
      dataIndex: 'bookbuyerCount',
      key: 'bookbuyerCount',
      align: 'center',
      render: (value) => (value ? value : 0),
    },
    {
      title: t('statistics.studentEnroll.column1'),
      dataIndex: 'prevReCount',
      key: 'prevReCount',
      align: 'center',
    },
    {
      title: t('statistics.studentEnroll.column2'),
      dataIndex: 'diffPercent',
      key: 'diffPercent',
      align: 'center',
      render: (value) => (value ? value : '-'),
    },
    {
      title: t('statistics.studentEnroll.column3'),
      dataIndex: 'plCount',
      key: 'plCount',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column2'),
      dataIndex: 's1Count',
      key: 's1Count',
      align: 'center',
    },
    {
      title: t('statistics.studentEnrollMonth.column3'),
      dataIndex: 's2Count',
      key: 's2Coount',
      align: 'center',
    },
  ];

  return (
    <div className="comm-table__area">
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          current: 1,
          pageSize: 999999999,
        }}
        rowClassName={(record: IEnrolledStudentSummary) =>
          record.campusCode === 'total' ? 'tfoot' : ''
        }
      />
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
      </div>
    </div>
  );
};

export default Summary;
